/**
 * FilterBar — search + tag + category + tier filters.
 */

import { useGallery } from '../state/gallery-store';
import './FilterBar.css';

export function FilterBar() {
  const {
    searchQuery,
    setSearchQuery,
    selectedTag,
    setSelectedTag,
    selectedCategory,
    setSelectedCategory,
    selectedTier,
    setSelectedTier,
    registry,
  } = useGallery();

  if (!registry) return null;

  const allTags = Array.from(
    new Set(registry.modules.flatMap((m) => m.tags))
  ).sort();

  const allCategories = Array.from(
    new Set(registry.modules.map((m) => m.category))
  ).sort();

  const allTiers: Array<'proprietary' | 'off-the-shelf' | 'generic'> = [
    'proprietary',
    'off-the-shelf',
    'generic',
  ];

  const hasFilter =
    searchQuery || selectedTag || selectedCategory || selectedTier;

  return (
    <div className="filter-bar">
      <input
        type="search"
        className="filter-bar__search"
        placeholder="Search modules…"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      <select
        className="filter-bar__select"
        value={selectedTag ?? ''}
        onChange={(e) => setSelectedTag(e.target.value || null)}
      >
        <option value="">All tags</option>
        {allTags.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </select>

      <select
        className="filter-bar__select"
        value={selectedCategory ?? ''}
        onChange={(e) => setSelectedCategory(e.target.value || null)}
      >
        <option value="">All categories</option>
        {allCategories.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>

      <select
        className="filter-bar__select"
        value={selectedTier ?? ''}
        onChange={(e) => setSelectedTier(e.target.value || null)}
      >
        <option value="">All tiers</option>
        {allTiers.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </select>

      {hasFilter && (
        <button
          type="button"
          className="filter-bar__clear"
          onClick={() => {
            setSearchQuery('');
            setSelectedTag(null);
            setSelectedCategory(null);
            setSelectedTier(null);
          }}
        >
          Clear
        </button>
      )}
    </div>
  );
}
